// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Alert, Box, CircularProgress } from '@mui/material';

// api
import { useGetConfigurableUtilityProvidersQuery } from '@/api/energy-analysis/utitlityProviderSlice';

// shared components
import PageHeader from '@/components/layout/PageHeader';

// relative
import UtilityProviderDatagrid from './UtilityProviderDatagrid';

const UtilityProviderPage = ({ utilityType }) => {
  const { t } = useTranslation('portfolio-analysis');

  const {
    data: providersData,
    isLoading,
    error,
  } = useGetConfigurableUtilityProvidersQuery({ utility_type: utilityType });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{t('utilityProviderPage.errorLoading')}</Alert>
      </Box>
    );
  }

  const providers = providersData?.providers || [];

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title={t('utilityProviderPage.title', { type: utilityType })}
        description={t('utilityProviderPage.description')}
        to={'../..'}
      />
      <UtilityProviderDatagrid
        providers={providers}
        utilityType={utilityType}
      />
    </Box>
  );
};

export default UtilityProviderPage;
